import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useFormContext, CheckboxView } from '@grandvisionhq/forms';

const ControlledCheckbox = (_param)=>{
    var { id , className , label , value , 'data-t': dataT , 'aria-label': ariaLabel , onChange: onChangeProp , required  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        "className",
        "label",
        "value",
        'data-t',
        'aria-label',
        "onChange",
        "required"
    ]);
    var ref;
    const formContext = useFormContext();
    const onChange = React.useCallback(({ checked  })=>{
        onChangeProp && onChangeProp(checked ? 'true' : '');
    }, [
        onChangeProp
    ]);
    var ref1;
    const { isTouched , isValid  } = (ref1 = (ref = formContext.getInitialState) === null || ref === void 0 ? void 0 : ref.call(formContext, id)) !== null && ref1 !== void 0 ? ref1 : {};
    return /*#__PURE__*/ React.createElement(CheckboxView, swcHelpers.extends({}, rest, {
        "data-t": dataT,
        id: id,
        className: classnames('controlled-checkbox', className),
        label: label,
        "aria-label": ariaLabel,
        value: value !== null && value !== void 0 ? value : '',
        checked: value === 'true',
        error: isTouched && isValid === false,
        errorId: `${id}_error`,
        required: required,
        onChange: onChange
    }));
};

export { ControlledCheckbox as default };
//# sourceMappingURL=ControlledCheckbox.js.map
